import { useEffect, useState } from 'react';

export const useNativeBrowserLoader = () => {
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    window.addEventListener('beforeunload', () => setIsRedirecting(true));
    window.addEventListener('pageshow', () => setIsRedirecting(false));

    return () => {
      window.removeEventListener('beforeunload', () => setIsRedirecting(true));
      window.removeEventListener('pageshow', () => setIsRedirecting(false));
    };
  }, []);

  return isRedirecting;
};
